import { css } from '@emotion/core';
import React from 'react';
import PropTypes from 'prop-types';
import style from './CountBar.style';

const CountBar = ({ label, icon: Icon, color, count, total }) => (
  <>
    <div
      aria-hidden
      css={[
        style.countBarIcon,
        css`
          color: ${color};
        `,
      ]}
    >
      {Icon ? <Icon /> : null}
    </div>
    <div aria-hidden css={[style.countBarCount]}>
      {count}
    </div>
    <div
      aria-label={`Count of ${label}: ${count}`}
      css={[
        style.countBar,
        css`
          background-color: ${color};
          width: ${Math.round((100 * count) / total)}%;
        `,
      ]}
    />
  </>
);

CountBar.defaultProps = {
  icon: null,
  color: 'gray',
  total: 0,
};

CountBar.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  color: PropTypes.string,
  count: PropTypes.number.isRequired,
  total: PropTypes.number,
};

CountBar.displayName = 'CountBar';

export default CountBar;
